import Link from "../../components/link";
import Center from "../../components/center";
import namedRoutes from "../../settings/routes";

const Questions = () => {
  return (
    <Center>
      <p>
        <strong>Questions or feedback?</strong> Connect on{" "}
        <Link external href={namedRoutes.links.facebook}>
          Facebook
        </Link>
        ,{" "}
        <Link external href={namedRoutes.links.instagram}>
          Instagram
        </Link>
        , or{" "}
        <Link external href={namedRoutes.links.contact}>
          email
        </Link>
        . If you found this post helpful, please share it with others!
      </p>
    </Center>
  );
};

export default Questions;
